// Leaf of the folder: the zod schemas reference these, so nothing is imported here.
export const GLOBAL_DOCUMENT_TEMPLATE_JSON_VERSION = 1 as const;

export enum DocumentTemplateElementType {
	TEXT = 'text',
	SMART_FIELD = 'smartField',
	IMAGE = 'image',
	SHAPE = 'shape',
	REPEAT = 'repeat',
	TABLE = 'table',
}

export enum DocumentTemplateShapeType {
	RECTANGLE = 'rectangle',
	LINE = 'line',
}
